import { render } from "./FlowErrorsViewer.vue?vue&type=template&id=398c7f10"
import script from "./FlowErrorsViewer.vue?vue&type=script&lang=js"
export * from "./FlowErrorsViewer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__